import { render } from "./CountryCodeSelector.vue?vue&type=template&id=75994bdc&scoped=true"
import script from "./CountryCodeSelector.vue?vue&type=script&lang=js"
export * from "./CountryCodeSelector.vue?vue&type=script&lang=js"

import "./CountryCodeSelector.vue?vue&type=style&index=0&id=75994bdc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75994bdc"]])

export default __exports__